import PropTypes from 'prop-types';
import React, {
    useContext, useState, useCallback, useEffect
} from 'react';

import { CommunityContext } from '../../../../context/ContextCreator';
import useUser from '../../../../utils/useUser';
import SuccessPopup from '../../../Elements/SuccessPopup';
import { AuthWrapper } from '../../AuthWrapper/AuthWrapper';

const ModerationFlag = ({ hash }) => {
    const { vote, getContent } = useContext(CommunityContext);
    const { user } = useUser();
    const { isLoggedIn, id, username } = user;
    const [showFlagMenu, setShowFlagMenu] = useState(false);
    const [isFlagged, setIsFlagged] = useState(false);

    const content = getContent(hash);

    const flagContent = useCallback(() => {
        vote(hash, 'flag');
        setShowFlagMenu(false);
    }, [hash, vote, setShowFlagMenu]);

    const closePopup = useCallback(() => {
        setShowFlagMenu(false);
    }, [setShowFlagMenu]);

    const handleFlagClick = useCallback(() => {
        if (!isLoggedIn) return;
        if (isFlagged) {
            vote(hash, 'flag');
            return;
        }
        setShowFlagMenu(true);
    }, [
        hash,
        isFlagged,
        isLoggedIn,
        vote,
        content.type,
        content.hash,
        id,
        username,
    ]);

    useEffect(() => {
        setIsFlagged(content.userFlagged);
    }, [setIsFlagged, content.userFlagged]);

    const label = isFlagged ? 'Flagged' : 'Flag';

    const authMetrics = {
        login_trigger: 'moderation-menu-flag',
        community_content_key: `${content.type}-${hash}`,
        community_on_comment: content.type === 'community-comment',
        fireMultiple: true,
    };

    return (
        <AuthWrapper
            redirectUrl={window?.location.pathname}
            loginTrigger={`moderation-menu-flag-${hash}`}
            customMetrics={authMetrics}
        >
            <style jsx global>
                {`
                    .component-ModerationFlag {
                        display: flex;
                        align-items: center;
                        width: 100%;
                    }
                    .component-ModerationFlag:focus {
                        outline: none;
                    }
                    .component-ModerationFlag .moderationFlag-label {
                        font-size: 14px;
                        line-height: 34px;
                        color: #353535;
                        padding-top: 2px;
                    }
                    .allContent {
                        height: 200px !important;
                    }
                    .content {
                        height: 128px !important;
                        min-height: 128px !important;
                    }
                    @media (max-width: 905px) {
                        .component-Elements-PopUp-SuccessPopup .content {
                            height: 163px !important;
                            min-height: 163px !important;
                        }
                        .component-Elements-PopUp-SuccessPopup .allContent {
                            width: 200px;
                        }
                        .component-ModerationAdmin .content {
                            height: 363px !important;
                            min-height: 363px !important;
                        }
                    }
                    @media (max-width: 770px) {
                        .component-Elements-PopUp-SuccessPopup .allContent {
                            width: 255px;
                            height: 255px !important;
                        }
                        .component-Elements-PopUp-SuccessPopup .content {
                            padding-left: 30px;
                            padding-right: 30px;
                            padding-top: 25px;
                        }
                    }
                `}
            </style>
            <div
                className="component-ModerationFlag"
                onClick={handleFlagClick}
                onKeyPress={handleFlagClick}
                role="button"
                tabIndex={0}
            >
                <span className="moderationFlag-label">{label}</span>
            </div>
            <div>
                {showFlagMenu && (
                    <SuccessPopup
                        title="Flag this item"
                        buttonOnClick={flagContent}
                        buttonText="Yes, please."
                        cancelButtonOnClick={closePopup}
                        secondaryText="Would you like to submit this item for review by our Community Manager?"
                        showLogo={false}
                        className="moderation-flag-style"
                    />
                )}
            </div>
        </AuthWrapper>
    );
};

ModerationFlag.propTypes = {
    hash: PropTypes.string.isRequired,
};
ModerationFlag.defaultProps = {};

ModerationFlag.displayName = 'ModerationFlag';

export default ModerationFlag;
